import { HTTP_Methods } from './Types';
import SimpleStore from '../../store/SimpleStore';
import { DynamicObject } from '../../utils/commonTypes';
import {
  HTTP_HEADER_KEYS,
  HTTP_HEADER_VALUES
} from '../../utils/constants/HttpMethodsConstants';

class APIService {
  private _method: HTTP_Methods = 'POST';
  private _headers: DynamicObject = {};

  get headers(): DynamicObject {
    return this._headers;
  }

  set method(newMethod: HTTP_Methods) {
    this._method = newMethod;
  }

  /**
   * Set header values for api call
   * @param headers list of headers to be used for api call - Post call adds Accept & content-type by default
   */
  public setHeaders(headers: string[]): APIService {
    headers.forEach((key) => {
      let value = '';
      if (
        key === HTTP_HEADER_KEYS.CONTENT_TYPE ||
        key == HTTP_HEADER_KEYS.ACCEPT
      ) {
        value = HTTP_HEADER_VALUES.APPLICATION_JSON;
      } else {
        value = SimpleStore.get(key) || '';
      }
      if (key === HTTP_HEADER_KEYS.AUTHORIZATION && value) {
        value = `bearer ${value}`;
      }
      this._headers[key] = value;
    });
    return this;
  }

  /**
   * Set header values for api call
   * @param customHeaders list of headers to override default values or value from Simple store
   */
  public setCustomHeaders(customHeaders: DynamicObject[]): APIService {
    customHeaders.forEach((header: DynamicObject) => {
      if (header.key && header.value) {
        const key: string = header.key;
        this._headers[key] = header.value;
      }
    });
    return this;
  }

  public resetHeaders(): void {
    this._headers = {};
  }

  public setTempToken(tempToken: string): void {
    this._headers[HTTP_HEADER_KEYS.AUTHORIZATION] = `bearer ${tempToken}`;
  }

  public setMethod(newMethod: HTTP_Methods): APIService {
    this._method = newMethod;
    return this;
  }

  public request<T>(body: T): RequestInit {
    return {
      headers: this._headers,
      method: this._method,
      body: body instanceof URLSearchParams ? body : JSON.stringify(body)
    };
  }

  public requestHeaders(): RequestInit {
    return {
      headers: this._headers,
      method: this._method
    };
  }
}

export class RequestBody<T> {
  constructor(private reqBody: T) {}

  get requestBody(): T {
    return this.reqBody;
  }

  set requestBody(newRequestBody: T) {
    this.reqBody = newRequestBody;
  }
}

export default APIService;
